import { RoutalPalette } from '@nx-smartmonkey/ui';

import RoutalLogo from '../../assets/img/routal-logo.svg';
import RoutalStarGreen from '../../assets/img/routal-star-green.svg';
import { FloatingLayout } from '../../components/public-layout/FloatingLayout';
import Text from '../../react-components/Text';
import { AuthContainer, AuthContent, AuthFooter, AuthHeader } from './Auth.styled';
import { Invitation } from './invitation';
import { Login } from './login';
import { Recovery } from './recovery';
import { Register } from './register';

type AuthProps = {
  route: `login` | `invitation` | `register` | `reset-password`;
};

export const Auth = ({ route }: AuthProps) => {
  return (
    <FloatingLayout
      leftAnimation={false}
      leftWidthPercentage={30}
      left={
        <AuthContainer
          container
          direction="column"
          wrap="nowrap"
          justifyContent="center"
          style={{ position: `relative`, minWidth: `360px`, borderRadius: `10px` }}
        >
          <AuthHeader item container justifyContent="flex-start" alignItems="flex-start">
            <img width="145" src={RoutalLogo} alt="" />
            <img width="14" src={RoutalStarGreen} alt="" />
          </AuthHeader>

          <AuthContent item>
            {route === `login` && <Login />}
            {route === `register` && <Register />}
            {route === `reset-password` && <Recovery />}
            {route === `invitation` && <Invitation />}
          </AuthContent>

          <AuthFooter />
        </AuthContainer>
      }
      right={
        <Text
          variant="h3"
          intlId="auth.claim.test"
          style={{
            fontWeight: `normal`,
            color: RoutalPalette.oldWhite,
            maxWidth: `min(60%, 800px)`,
            textAlign: `center`,
            zIndex: 1,
          }}
        />
      }
    />
  );
};
